import React, { Component } from "react"
import { businessCorporateInfo } from "../../BackendServices/registrationAPI"
import { withTranslation } from "react-i18next"
import TextInput from "../common/TextInput"
import ActivationCode from "./ActivationCode"
import { encrypt } from "../../BackendServices/generic"
import ErrorAlert from "../common/ErrorAlert";

const win = window;
const lang = win['lang'];
const rtl = lang === 'ar';

class BusinessRegistration extends Component {

    state = {
        commercialId: '',
        apMobileNumber: '',
        errors: { commercialId: '', apMobileNumber: '' },
        formIsValid: false,
        isSuccess: false,
        genericError: null,
        loading: false,
        apFirstName: "",
        apLastName: "",
        companyName: ""
    }

    handleValidation(formData) {
        let errors = {};
        let formIsValid = false;

        for (var [key, value] of formData) {
            if (key === 'commercialId') {
                if (value === null || value === '') {
                    errors['commercialId'] = "required";
                }
            }
            if (key === 'apMobileNumber') {
                if (value === null || value === '') {
                    errors['apMobileNumber'] = "required";
                } else if (typeof value !== "undefined") {
                    if (!value.match(/^(((9665)([0-9]{8}))||((05)([0-9]{8}))||((96618)([0-9]{7})))$/)) {
                        errors['apMobileNumber'] = "msisdn_format";
                    }
                }
            }
        }
        if ((JSON.stringify(errors) === '{}') && this.state.commercialId !== '' && this.state.apMobileNumber !== '') {
            formIsValid = true
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    handaleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        let formIsValid = false;
        formIsValid = this.handleValidation(formData.entries())
        if (formIsValid) {
            await this.businessCorporateInfo();
        }
    }

    businessCorporateInfo = async () => {
        const { apMobileNumber } = this.state;
        let mobileNumber;
        if (apMobileNumber.startsWith('05')) {
            mobileNumber = apMobileNumber.replace('05', '9665')
        } else {
            mobileNumber = apMobileNumber
        }

        let requestBody = {
            "corporateInfo": {
                "apMobileNumber": encrypt(mobileNumber),
                "commercialId": encrypt(this.state.commercialId.trim())
            },
            "clientInfo": {
                "clientId": this.props.clientId,
                ...(this.props.clientId !== window.OAUTHUserName && { "redirectUrl": this.props.redirectURL })
            }
        }

        await this.setState({
            loading: true
        })
        try {
            let result = await businessCorporateInfo(requestBody)
            if (result.status.code === 'MAPI-000') {
                this.setState({
                    transactionId: result.transactionId,
                    isSuccess: true,
                    loading: false,
                    apFirstName: result.apFirstName,
                    apLastName: result.apLastName,
                    companyName: result.companyName
                })
            }
        } catch (error) {
            this.setState({
                genericError: error.message,
                loading: false
            })
        }
    }

    handleChange = async (e) => {
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value,
        })
    }

    render() {
        const { t } = this.props;

        return (
            <React.Fragment>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}
                {!this.state.isSuccess &&
                    (
                        <section>
                            <div className="loginIntroTextContainer">
                                <h3>{t("welcome_business_title")}</h3>
                                <p className="headerdescription">{t("welcome_corporate_desc")}</p>
                            </div>
                            <div className="tabs">
                                <div className="tab-content">
                                    {this.state.genericError && (
                                        <>
                                            <ErrorAlert error={this.state.genericError} />
                                            <div style={{ display: "none" }} className={this.state.genericError ? "api-error" : ""}>{this.state.genericError}</div>
                                        </>
                                    )}
                                    <form onSubmit={this.handaleSubmit} id="bussiness-registration-form">
                                        <TextInput id="commercialId" label={"commercial_reg_id"} name={"commercialId"} value={this.state.commercialId} type={"text"} error={this.state.errors.commercialId} handleChange={this.handleChange} hint={t("commercial_reg_id_hint")}/>
                                        <TextInput id="apMobileNumber" label={"authorized_mobile_no"} name={"apMobileNumber"} value={this.state.apMobileNumber} type={"text"} error={this.state.errors.apMobileNumber} handleChange={this.handleChange} hint={t("authorized_person_no_hint")} />
                                        <button id="activationcode" type="submit" className="btn min_outlin_btn activationcodeButton active">
                                            {t("get_activation_code_btn")}
                                            <i className="fa fa-arrow-right" aria-hidden="true" />
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </section>
                    )}
                {this.state.isSuccess && (
                    <ActivationCode
                        redirectURL={this.props.redirectURL}
                        msisdn={this.state.apMobileNumber}
                        transactionId={this.state.transactionId}
                        apFirstName={this.state.apFirstName}
                        apLastName={this.state.apLastName}
                        companyName={this.state.companyName}
                    />
                )}
            </React.Fragment>)
    }
}

export default withTranslation()(BusinessRegistration);